export const environment = {
  production      : false,
  appName         : 'EasyAngular',
  envName         : 'dev',
  defaultLanguage : 'en',
  // apiBaseUrl      : 'http://localhost:3003/api/v1',
  // frontendEndUrl  : 'http://localhost:4200',
  frontendEndUrl  : 'https://ttddash-dev.silverpush.live',
  apiBaseUrl      : 'https://ttddash-dev.silverpush.live/api/v1',
  enableRuleLogicJson : true,
};
